import { AddSellerDialogUi } from '@/components/Seller/AddSellerDialog/AddSellerDialogUi';
import { CreateSellerRequest } from '@/data/api/model/sellers/SellersDto';

export function addSellerDialogUiToCreateSellerRequest(
  input: AddSellerDialogUi
): CreateSellerRequest {
  return {
    business_name: input.businessName,
    full_name: input.responsibleName,
    tax_id: input.rfc,
    tax_regime_id: input.fiscalRegime,
    business_legal_name: input.legalName,
    email: input.email,
    phone: input.phoneNumber,
    min_order_amount: Number(input.purchaseMinAmount),
    password: input.password,
  };
}
